import styled from 'astroturf/react'
import { useDispatch, useSelector } from 'react-redux'
const colorTextStandard = 'var(--colorTextStandard, var(--coreColorNeutral900))'
const colorBgGrey2 = 'var(--color-bg-grey-2, #FAFAFA)'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
import { MinimalButton } from '@calendly/ui/components/minimal-button'

import Marker from 'components/select_date_time/marker'
import { eventTypeSelector } from 'root-api'
import { currentUserSelector } from 'selectors/user'
import { updateSelectedSpots } from 'actions/spot'
import { syncSpotUrlParameters } from 'actions/navigation'
import { calendarSpotsWithoutConflictsSelector } from 'selectors/mutual_availability'
import { useI18n } from 'locales'
import _Container from "info-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/mutual_availability_notice/info.js?styleId=Container";


const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container
})

const Info = () => {
  const { i18n } = useI18n()
  const dispatch = useDispatch()
  const eventType = useSelector(eventTypeSelector)
  const currentUser = useSelector(currentUserSelector)
  const availableSpots = useSelector(calendarSpotsWithoutConflictsSelector)
  const isFlatSpotpicker = eventType.spotpicker_type === 'FlatSpotpicker'
  const locale = currentUser && currentUser.locale
  const selectAllAvailableSpots = () => {
    dispatch(updateSelectedSpots(availableSpots))
    dispatch(syncSpotUrlParameters())
  }

  return (
    <Container isFlatSpotpicker={isFlatSpotpicker}>
      <Marker />
      {i18n.t('publisher.mutual_availability.available', { locale })}
      {isFlatSpotpicker && (
        <MinimalButton spacingLeft={12} onClick={selectAllAvailableSpots}>
          {i18n.t('publisher.mutual_availability.select_all', { locale })}
        </MinimalButton>
      )}
    </Container>
  )
}

export default Info
